import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { actions as depositsActions } from "reducers/deposits";
import { actions as formActions } from "reducers/form";

export const useCancelRenewalTransaction = () => {
    const { id } = useParams();
    const { pathname, state = {} } = useLocation();
    const dispatch = useDispatch();
    const { transaction, fetching } = useSelector((_state) => _state.form);
    const { user } = useSelector((_state) => _state.session);

    const isBackoffice = pathname.includes("backoffice");
    const showSignButton = isEmpty(transaction?.signatures?.find((sign) => sign.idUser === user?.userId));

    useEffect(() => {
        if (id && isEmpty(state?.transaction)) {
            dispatch(formActions.readTransactionTicket(id));
        }
    }, [id, dispatch]);

    useEffect(
        () => () => {
            dispatch(depositsActions.cleanDepositTicket());
        },
        [],
    );

    return { isLoading: fetching, transaction, dispatch, showSignButton, id, isBackoffice };
};

export default useCancelRenewalTransaction;
